export default function PendingApprovalPartial({
  order,
  setSingleOrderToPay,
  handelPaymentModal,
  formatToMMDDYYYY,
  selectedOrders,
  handleSelectOrder,
  index,
}) {
  return (
    <div key={order.COI_ID} className="order-item">
      <span className="item-number">{index + 1}</span>
      <div className="order-image">
        <img
          src={`${process.env.REACT_APP_BASE_URL}Assets/Products/${order.PD_ID}/${order.IMG[0]}`}
          alt={order.ProductName}
        />
      </div>

      <div className="order-details">
        <span className="ord-prod-name">
          {order.ProductName}{" "}
          <b>&nbsp; &nbsp; &nbsp; &nbsp;x{order.Quantity}</b>
        </span>
        <span>UNIT PRICE : PHP {order.ProductPrice}</span>
        <span>DATE ORDERED : {formatToMMDDYYYY(order.DateOrdered)}</span>
      </div>

      <div className="order-payment">
        <span>TOTAL PRICE : {order.UnitPrice * order.Quantity}</span>
        <span>DOWNPAYMENT : {order.Downpayment}</span>
        <span>BALANCE : {order.Balance}</span>
      </div>
    </div>
  );
}
